import React from "react";

export const IconCloseSvg = ({ color = "#7C7C7C", "data-testid": dataTestId = null, ...props }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			data-testid={dataTestId}
			{...props}
		>
			<path
				d="M10 0.999933L9.00007 0L5 4.00007L0.999933 0L0 0.999933L4.00007 5L0 9.00007L0.999933 10L5 5.99993L9.00007 10L10 9.00007L5.99993 5L10 0.999933Z"
				fill={color}
			/>
		</svg>
	);
};
